import { PaginationPcApiResponse } from '@/api/pc-api/types';
import { DatePickerType } from '@/constants/datePicker';
import { DEFAULT_PAGE_SIZE } from '@/constants/pagination';
import { CountMap } from '@/constants/usage';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type UsageSearchQuery = {
  id: string;
  datePickerType: DatePickerType;
  start?: string;
  end?: string;
  companyName?: string;
  svcName?: string;
  settledId?: string;
  appId?: string;
  productIds?: string[];
  page: number;
};

export type UsageData = {
  appId?: string; // MYDATA 타입은 없음
  companyName: string;
  countMap: {
    [CountMap.REQUEST]?: number;
    [CountMap.SIGN]?: number;
    [CountMap.RESULT]?: number;
    [CountMap.SIGN_FOR_READ]?: number;
    [CountMap.FIRST_OTT_VERIFY]?: number;
    [CountMap.NOTICE_TALK_RECEIVE]?: number;
    [CountMap.SIGN_DOCUMENT]?: number;
    [CountMap.SEND_DOCUMENT]?: number;
    [CountMap.READ_DOCUMENT]?: number;
  };
  date: string;
  productCode: string;
  settleId: string;
  svcName: string;
};

export const getStatSearch = (params: UsageSearchQuery) => {
  return api<PaginationPcApiResponse<UsageData[]>>('get', `/pc-api/v1/${PREFIX_PATH}/stat/search`, {
    ...params,
    size: DEFAULT_PAGE_SIZE
  });
};
